import { Injectable } from '@angular/core';

// Definizione dell'interfaccia per il formData
interface FormData {
  experienceId: string;
  language: string;
  date: string;
  time: string;
  numberOfPeople: number;
  people: number[];
  extras: string;
  totalPrice: number;
  experience_price_labels: {
    count: number;
    id: number;
    title_translations: { [key: string]: string };
    price_cents: number;
    price_currency: string;
    position: number;
    experience_id: string;
    created_at: string;
    updated_at: string;
    quantity: number;
  }[];
  price01_label_with_count: {
    label: string;
    count: number;
  };
  isReservation: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  // Definizione del formData nel servizio con tipizzazione
  private formData: FormData = {
    experienceId: '',
    language: '',
    date: '',
    time: '',
    numberOfPeople: 0,
    people: [],
    extras: '',
    totalPrice: 0,
    experience_price_labels: [],
    price01_label_with_count: {
      label: '',
      count: 0
    },
    isReservation: true // Imposta il valore predefinito
  };

  constructor() { }

  // Metodo per impostare i dati del form
  setFormData(formData: FormData) {
    this.formData = formData;
  }

  // Metodo per ottenere i dati del form
  getFormData(): FormData {
    return this.formData;
  }

  // Metodo per resettare i dati del form
  resetFormData() {
    this.formData = {
      experienceId: '',
      language: '',
      date: '',
      time: '',
      numberOfPeople: 0,
      people: [],
      extras: '',
      totalPrice: 0,
      experience_price_labels: [],
      price01_label_with_count: {
        label: '',
        count: 0
      },
      isReservation: true // Resetta al valore predefinito
    };
  }
}
